import React from "react";
import AllSellingPriceHistories from "./SellingPriceHistoryModule/AllSellingPriceHistories";

const SellingPriceHistories = () => {
  return (
    <div>
      <AllSellingPriceHistories />
    </div>
  );
};

export default SellingPriceHistories;
